import { IOperationHandler } from '@ms/items-view/lib/private/store/actions/implementOperation';
import { spFolderItemSetKeyFacet } from '../../../dataSource/Keys';
import { getItemsOperation } from '@ms/items-view/lib/private/operations/getItems';
import {
  createSingleItemOperationHandler,
  ISingleOperationPayload,
  IOperationHandlerThunkAction,
  registerOperationHandler
} from '@ms/items-view/lib/private/addons/registerOperationHandler';
import { getFolderItemSetForItemSetKey } from '../../../operations/getFolderItemSetForItemSetKey';
import {
  createAddon,
  IAddon
} from '@ms/items-view/lib/private/addons/registerOperationHandler';
import {
  IItemCacheDispatch,
} from '@ms/items-view/lib/private/store/actions/ItemCacheActions';

const spFolderItemSetGetItemsOperationHandler:
  IOperationHandler<typeof spFolderItemSetKeyFacet.type, typeof getItemsOperation.type> =
  createSingleItemOperationHandler({
    maxParallelOperationCount: 8
  })(getSPFolderItemSet);

function getSPFolderItemSet(
  payload: ISingleOperationPayload<typeof spFolderItemSetKeyFacet.type, typeof getItemsOperation.type>,
  options: {
    skipCache?: boolean;
  } = {}
): IOperationHandlerThunkAction {
  return getFolderItemSetForItemSetKey(spFolderItemSetKeyFacet.deserialize(payload.itemKey))(payload, options);
}

export const getSPFolderItemSetAddon: IAddon = createAddon(() => {
  return async (dispatch: IItemCacheDispatch) => {
    dispatch(registerOperationHandler(spFolderItemSetKeyFacet, getItemsOperation)(
      spFolderItemSetGetItemsOperationHandler
    ));
  };
});
